import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Topo from "../Topo/topo";
import { emplacarAPI } from "../../servicos/emplacar";
import { FormField } from "../ui/form-field";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import EnvioLoteSection from "./Lote/EnvioLoteSection";
import { Controller, useForm } from "react-hook-form";
import { toast } from "sonner";


function Incluir() {

    const breadcrumbs = ['Home', 'Emplacar', 'Novo'];

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            ve101_key_nfe: '',
            ve101_dsc_chassi: '',
        },
        mode: 'onBlur',
    });

    const [ve101_key_public, set101_key_public] = useState('');
    const [ve101_url_processo, set101_url_processo] = useState('');


    const [mostraSalvar, setmostraSalvar] = useState(true);
    const [mostraEnviar, setmostraEnviar] = useState(false);
    const [mostraDownload, setmostraDownload] = useState(false);
    const [mostraNovo, setmostraNovo] = useState(false);

    let navigate = useNavigate();

    const Voltar = () => {
        let path = '/filiado/emplacar';
        navigate(path);
    }

    const NovoCadastro = () => {

        reset();
        set101_key_public('');
        set101_url_processo('');

        setmostraSalvar(true);
        setmostraEnviar(false);
        setmostraDownload(false);
        setmostraNovo(false);

    };

    const sanitizeNfeKey = (valor = '') => valor.replace(/\D/g, '').slice(0, 44);
    const sanitizeChassi = (valor = '') => valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 17);

    const onSubmit = async (values) => {

        setmostraSalvar(false);

        try {
            const payload = {
                ve101_key_nfe: sanitizeNfeKey(values.ve101_key_nfe),
                ve101_dsc_chassi: sanitizeChassi(values.ve101_dsc_chassi),
            };
            const resposta = await emplacarAPI.post('/', payload);
            set101_key_public(resposta.data.emplacar.ve101_key_public);
            toast.success('Registro criado com sucesso. Agora clique em DetranPR para registrar o veículo.');
            setmostraEnviar(true);
            setmostraDownload(false);
            setmostraNovo(false);
        } catch (erro) {
            let mensagem = 'Ops! Ocorreu um erro inesperado.';
            if (erro?.response?.data?.message) {
                if (erro.response?.status === 401 || (erro.response?.status === 406 && erro?.response?.data?.message === "Token Inválido")) {
                    mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
                } else {
                    mensagem = erro.response.data.message;
                }
            } else if (erro.response?.status === 401) {
                mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
            }
            toast.error(mensagem);
            setmostraSalvar(true);
        }

    };

    const onInvalidSubmit = () => {
        toast.error('Por favor, corrija os campos destacados.');
        setmostraSalvar(true);
    };

    const EnviarDetran = async (event) => {
        event.preventDefault();

        if (!ve101_key_public) {
            toast.error('Registre o veículo antes de enviar ao Detran.');
            return;
        }

        setmostraEnviar(false);

        try {
            const resposta = await emplacarAPI.get(`/Processo/${ve101_key_public}`);
            toast.success(`Processo (${resposta.data.emplacar.ve101_num_processo}) criado com sucesso. Clique em Download.`);
            set101_url_processo(resposta.data.emplacar.ve101_url_processo);
            setmostraDownload(true);
            setmostraNovo(true);
        } catch (erro) {
            let mensagem = 'Ops! Ocorreu um erro inesperado.';
            if (erro?.response?.data?.message) {
                if ((erro.response?.status === 401) || ((erro.response?.status === 406) && erro?.response?.data?.message === "Token Inválido")) {
                    mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
                } else {
                    mensagem = erro.response.data.message;
                }
            } else if (erro.response?.status === 401) {
                mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
            }
            toast.error(mensagem);
            setmostraEnviar(true);
        }
    };


    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Registrar Veículo' breadcrumbs={breadcrumbs} btnincluir={false} admin={false} />
                <EnvioLoteSection />
                <div class="row row-padding-conteudo">
                    <div class="col-12">
                        <form class="row gy-4 gx-4" onSubmit={handleSubmit(onSubmit, onInvalidSubmit)}>
                            <div class="col-md-6">
                                <FormField
                                    id="ve101_key_nfe"
                                    label="Chave da NF-e"
                                    error={errors.ve101_key_nfe?.message}
                                >
                                    <Controller
                                        name="ve101_key_nfe"
                                        control={control}
                                        rules={{
                                            required: 'Informe a chave da NF-e.',
                                            validate: (valor) => (
                                                sanitizeNfeKey(valor).length === 44 || 'A chave deve conter 44 dígitos.'
                                            ),
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="ve101_key_nfe"
                                                inputMode="numeric"
                                                maxLength={44}
                                                onChange={(evento) => field.onChange(sanitizeNfeKey(evento.target.value))}
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="ve101_dsc_chassi"
                                    label="Chassi"
                                    error={errors.ve101_dsc_chassi?.message}
                                >
                                    <Controller
                                        name="ve101_dsc_chassi"
                                        control={control}
                                        rules={{
                                            required: 'Informe o chassi.',
                                            validate: (valor) => (
                                                sanitizeChassi(valor).length === 17 || 'O chassi deve conter 17 caracteres.'
                                            ),
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="ve101_dsc_chassi"
                                                maxLength={17}
                                                onChange={(evento) => field.onChange(sanitizeChassi(evento.target.value))}
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>

                            <div class="col-12 tw-flex tw-flex-wrap tw-justify-end tw-gap-3 tw-pt-2">
                                <Button type="button" variant="outline" onClick={Voltar} className="tw-min-w-[120px] tw-text-slate-700 dark:tw-text-white">
                                    Voltar
                                </Button>
                                {mostraSalvar && (
                                    <Button type="submit" className="tw-min-w-[140px]" disabled={isSubmitting}>
                                        {isSubmitting ? 'Salvando...' : 'Salvar'}
                                    </Button>
                                )}
                                {mostraEnviar && (
                                    <Button type="button" onClick={EnviarDetran} className="tw-min-w-[140px]">
                                        DetranPR
                                    </Button>
                                )}
                                {mostraDownload && (
                                    <Button asChild className="tw-min-w-[140px]">
                                        <a href={ve101_url_processo} target="_blank" rel="noreferrer">Download</a>
                                    </Button>
                                )}
                                {mostraNovo && (
                                    <Button type="button" onClick={NovoCadastro} className="tw-min-w-[140px]">
                                        Novo
                                    </Button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Incluir;

